"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeFieldType = void 0;
/**
 * Field types that can be used in the Form Schema
 * @see FormJSONObject
 */
exports.IkeFieldType = {
    DATE: 'date',
    FORM: 'form',
    LOCATION: 'location',
    NESTED_LIST: 'nestedlist',
    NUMBER: 'number',
    SELECT_LIST: 'selectlist',
    TEXT: 'text',
    HEIGHT: 'height',
    TRUE_SIZE: 'truesizecapture',
    YES_NO: 'yesno',
    /**
     * Generic image with no sensor data
     * @see IkeCaptureType.IMAGE
     */
    IMAGE: 'image',
    VECTOR: 'vector',
    VERTICAL_SEPARATION: 'verticalseparation',
    FILE_TOOL: 'filetool',
    ANCHOR: 'anchor',
};
//# sourceMappingURL=field.js.map